import { GateSerializer } from './gate.serializer'
import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Gate } from './gate'

@Injectable()
export class GateService extends ResourceService<Gate> {
  constructor(public http: HttpClient, gateSerializer: GateSerializer) {
    super(http, `${environment.backendApiUrl}/gates`, gateSerializer)
  }
}
